import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "../../../modules/material/material.module";
import { TranslateModule } from "@ngx-translate/core";
import { TableModule } from "../../shared/components/table/onsip-table.module";
import { OnsipFormsModule } from "../../shared/components/forms/onsip-forms.module";
import { HeaderModule } from "../../shared/components/layout/header/header.module";
import { FormEventTrackingModule } from "../../shared/components/analytics/form-event-tracking.module";
import { PipesModule } from "../../shared/pipes/pipes.module";
import { RouterModule } from "@angular/router";
import { AudioRecorderModule } from "../../shared/components/audioRecorder/audio-recorder.module";

import { AdminRecordingLibraryComponent } from "./recording-library.component";
import { RecordingShelfContainerComponent } from "./recordingShelf/recording-shelf-container.component";
import { RecordingShelfViewComponent } from "./recordingShelf/recordingShelfView/recording-shelf-view.component";
import { RecordingShelfEditComponent } from "./recordingShelf/recordingShelfEdit/recording-shelf-edit.component";
import { RecordingRoutingModule } from "@onsip/web/features/administrators/recording/recordingRouting.module";
import { TableDataLoadContainerModule } from "../../shared/components/tableDataLoadContainer/table-data-load-container.module";
import { RecordingSetupComponent } from "@onsip/web/features/administrators/recording/recordingSetup/recording-setup.component";
import { RecordingContainerComponent } from "@onsip/web/features/administrators/recording/recordingContainer/recording-container.component";
import { TogglableRecorderModule } from "../../shared/components/togglableRecorder/togglable-recorder.module";
import { RecManagerLinkModule } from "@onsip/web/features/shared/components/recManagerLink/rec-manager-link.module";
import { LoadingContainerComponent } from "../../shared/components/loadingContainer/loading-container.component";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    TranslateModule,
    TableModule,
    OnsipFormsModule,
    HeaderModule,
    FormEventTrackingModule,
    PipesModule,
    AudioRecorderModule,
    RecordingRoutingModule,
    TableDataLoadContainerModule,
    TogglableRecorderModule,
    RecManagerLinkModule,
    LoadingContainerComponent
  ],
  declarations: [
    AdminRecordingLibraryComponent,
    RecordingShelfContainerComponent,
    RecordingShelfViewComponent,
    RecordingShelfEditComponent,
    RecordingSetupComponent,
    RecordingContainerComponent
  ]
})
export class AdminRecordingModule {}
